import React from "react";

import Button from "../../atoms/button/button";
import MembersSlider from "../members-slider/membersSlider";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

import "./members.scss";

const Members = (props: ReferenciaContenido) => {
  const testimonies = Array();

  const handleMembers = () => {
    for (let i = 0; i < props.referenciaPlantillaContenido.length; i++) {
      let testimony = {
        imagenPrincipal: {
          url:
            props.referenciaPlantillaContenido[i].imagenPrincipal[0].file.url,
          alt: props.referenciaPlantillaContenido[i].imagenPrincipal[0].title,
        },
        tituloBanner: props.referenciaPlantillaContenido[i].tituloBanner,
        tituloDescripcion:
          props.referenciaPlantillaContenido[i].tituloDescripcion,
      };
      if (typeof props.referenciaPlantillaContenido !== "undefined") {
        testimonies.push(testimony);
      }
    }

    return testimonies;
  };

  handleMembers();

  return (
    <div className="m-testimonies">
      <div className="m-testimonies__head">
        <h2 className="m-testimonies__head-title">
          Amigos miembros de este club
        </h2>
        <div
          className={`m-testimonies__see-all ${
            testimonies.length > 30 ? "m-testimonies__see-all--show" : ""
          }`}
        >
          <Button
            type="button"
            text="VER TODO"
            isDisabled={false}
            classname="m-testimonies__head-btn"
          />
        </div>
      </div>

      <div className="m-testimonies__slider">
        <MembersSlider testimonies={testimonies} />
      </div>
    </div>
  );
};

export default Members;
